import { render, staticRenderFns } from "./gain-loss-line-chart.vue?vue&type=template&id=094d6c40&"
import script from "./gain-loss-line-chart.vue?vue&type=script&lang=js&"
export * from "./gain-loss-line-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports